export default __webpack_public_path__ + "static/media/sw_3.bcffd431.png";